import styled from 'styled-components'

import type { ReleaseInfoModel } from 'models/Navbar/ReleaseInfoModel'
import type { OperationStatus } from 'models/common/OperationStatus'
import { SvgIcons } from 'components/Icon/Icon'
import { Column, Row } from 'components/Table/Table'
import type { Instance } from 'mobx-state-tree'
import { observer } from 'mobx-react'

interface ReleaseInfoProps {
  releaseInfo: Instance<typeof ReleaseInfoModel> | null
  fetchStatus: OperationStatus
}

const FlytrexLogoContainer = styled.div`
  margin: 1em 1em;
`

const VersionNumberContainer = styled.div`
  font-weight: bold;
`

export const AboutDialog = observer(({ fetchStatus, releaseInfo }: ReleaseInfoProps) => {
  const releaseInfoText = (
    fetchStatus: OperationStatus,
    value?: string,
  ): string => {
    if (fetchStatus.inProgress) {
      return 'Loading...'
    }
    if (fetchStatus.error) {
      return 'Error loading version'
    }
    return value ?? 'Unknown'
  }
  return (
    <Column alignItems='center'>
      <FlytrexLogoContainer>
        <SvgIcons.FlytrexLogoSmallSvg />
      </FlytrexLogoContainer>
      <Row>
        <span>Release version:</span>
        <VersionNumberContainer>
          <span>1.8.0</span>
        </VersionNumberContainer>
      </Row>
      <Row>
        <span>Frontend build ID:</span>
        <VersionNumberContainer>
          <span>{releaseInfoText(fetchStatus, releaseInfo?.frontend_version)}</span>
        </VersionNumberContainer>
      </Row>
      <Row>
        <span>GCS build ID:</span>
        <VersionNumberContainer>
          <span>{releaseInfoText(fetchStatus, releaseInfo?.gcs_backend_version)}</span>
        </VersionNumberContainer>
      </Row>
      <Row>
        <span>Oversight build ID:</span>
        <VersionNumberContainer>
          <span>{releaseInfoText(fetchStatus, releaseInfo?.oversight_backend_version)}</span>
        </VersionNumberContainer>
      </Row>
    </Column>
  )
})
